module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 if (gon.display_options.is_interactive) {;
__p += '\n<div id="mobile_navbar_lightbox" class="mfp-hide"></div>\n<div id="mobile_filters_block" class="' +
((__t = ( getClasses() )) == null ? '' : __t) +
'">\n	<div id="search_region" class="filter_wrapper" analytics-id="search"></div>\n	<div id="mobile_button"></div>\n	<div id="location_region" class="filter_wrapper" analytics-id="location filter"></div>\n</div>\n<div id="map_region" class="mobile_map_region"></div>\n<div id="results_bar_region" class="mobile_results "></div>\n';
};


}
return __p
}